import { FunctionComponent, useEffect, useState } from "react";
import Navbar from "../Components/Navbar/Navbar";
import { Route } from "react-router-dom";
import styles from '../Screens/Analytics/Analytics.module.css'
import AnalyticsSideNav from "../Components/AnalyticsSideNav/AnalyticsSideNav";
import LeadManagerAnalytics from "../Screens/Analytics/LeadManagerAnalytics";
import { fetchOrganizationsUsersAuthId } from "../Services/users";
import { connect, useDispatch } from "react-redux";
import FAQPanelReplicate from "../Screens/SuperAdminFAQPanel/FAQPanelReplicate"
import NewsPanelReplicateAdmin from "../Screens/NewsPanel/NewsPanelReplicateAdmin";
import ViewBooking from "../Screens/Booking/AddBooking";
import MyProfile from "../Screens/MyProfile/MyProfile";
import PolicyPrivacy from "../Screens/PolicyPrivacy/PolicyPrivacy";
import AboutUs from "../Screens/AboutUs/AboutUs";
import UserPanelReplicateAdmin from "../Screens/UserPanel/UserPanelReplicateAdmin";
import TaskPanelReplicateAdmin from "../Screens/TasksPanel/TaskPanelReplicateAdmin";
import CallLogsPanelReplicateAdmin from "../Screens/CallLogsPanel/CallLogsPanelReplicateAdmin";
import SortPanelReplicateAdmin from "../Screens/UserPanel/SortPanelReplicateAdmin";
import BookingReplicateAdmin from "../Screens/Booking/BookingReplicateAdmin";
import ProjectsPanelReplicateAdmin from "../Screens/ProjectsPanel/ProjectsPanelReplicateAdmin";
import ApiPanelReplicateAdmin from "../Screens/ApiPanel/ApiPanelReplicateAdmin";
import AddProjectSuperAdmin from "../Screens/AddProject/AddProjectSuperAdmin";

type props = {
  user: any;
  history: any;
  leadsStage: any;
  organizationUsers: any;
  showDeactivationAlert: any;
  paymentStatus: any;
};

const ReplicateAdminRoute: FunctionComponent<props> = ({
  history,
  user,
  leadsStage,
  organizationUsers,
  showDeactivationAlert,
  paymentStatus
}) => {
  const dispatcher = useDispatch();

  useEffect(() => {
    const localStoreOrgObj = localStorage.getItem("superAdminSelectedOrg");
    if (localStoreOrgObj != null) {
      const covertObj = JSON.parse(localStoreOrgObj);
      const orgAuthId = covertObj.value;

      if (orgAuthId) {
        const unSub = fetchOrganizationsUsersAuthId(
          dispatcher,
          orgAuthId,
          user
        );
        return () => {
          unSub();
        };
      }
    }
  }, [user, localStorage.getItem("superAdminSelectedOrg")]);

  return (
    <>
      <Navbar
        props={{ history }}
        title={"Organizations"}
        path={"/"}
        leadManger={false}
      />
      <div className={styles.parent} style={{ overflow: "hidden", height: "100vh" }}>
        <AnalyticsSideNav
          props={{ history }}
          title={"Organizations"}
          path={"/"}
          leadManger={false}
          operationManger={false}
        />
        <Route exact path="/" component={UserPanelReplicateAdmin} />
        <Route path="/analytics" component={LeadManagerAnalytics} />
        <Route path="/faq" component={FAQPanelReplicate} />
        <Route path="/news" component={NewsPanelReplicateAdmin} />
        <Route path="/profile" component={MyProfile} />
        <Route path="/privacy-policy" component={PolicyPrivacy} />
        <Route path="/about-us" component={AboutUs} />
        <Route path="/tasks" component={TaskPanelReplicateAdmin} />
        <Route path="/callLogs" component={CallLogsPanelReplicateAdmin} />
        <Route path="/booking" component={BookingReplicateAdmin} />
        <Route path="/viewBookingDetails" component={ViewBooking} />
        <Route path="/apis" component={ApiPanelReplicateAdmin} />
         <Route path="/sorted" component={SortPanelReplicateAdmin} />
        <Route path="/projects" component={ProjectsPanelReplicateAdmin} />
        <Route path="/addProjects" component={AddProjectSuperAdmin} />
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    leadsStage: state.leadsStage.stage,
    organizationUsers: state.organizationUsers.data,
    showDeactivationAlert: state.organization.showDeactivationAlert,
    paymentStatus: state.organization.paymentStatus
  };
};
export default connect(mapStateToProps)(ReplicateAdminRoute);

